import { render, staticRenderFns } from "./ClientInformationSave.vue?vue&type=template&id=49172234&scoped=true&"
import script from "./ClientInformationSave.vue?vue&type=script&lang=ts&"
export * from "./ClientInformationSave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49172234",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49172234')) {
      api.createRecord('49172234', component.options)
    } else {
      api.reload('49172234', component.options)
    }
    module.hot.accept("./ClientInformationSave.vue?vue&type=template&id=49172234&scoped=true&", function () {
      api.rerender('49172234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/ClientInformationSave.vue"
export default component.exports